<div class="select-search" [ngClass]="{ disabled }">
  <div
    class="d-flex align-items-center no-select"
    mat-button
    [matMenuTriggerFor]="locationsMenu"
  >
    <div class="flex-grow-1 one-line-text ml-2">
      <!-- <p>{{ selectItem.name }}</p> -->
      <input type="text" name="channel logo name" value="{{ selectItem.name }}" readonly />
    </div>
    <mat-icon>expand_more</mat-icon>
  </div>
  <mat-menu #locationsMenu="matMenu" yPosition="below" class="options-container">
    <div class="px-3 pt-3 pb-2">
      <input
        class="form-control text-dark"
        [(ngModel)]="filterText"
        type="text"
        placeholder="Filter logos"
        (ngModelChange)="keyPressed()"
        (click)="$event.stopPropagation(); $event.preventDefault()"
        (focusout)="refocus($event)"
      />
    </div>
    <div
      class="py-2 px-3 d-flex align-items-end no-select logos-list-container"
      *ngFor="let item of filteredLogos"
      (click)="menuItemClicked($event, item)"
      style="cursor: pointer"
    >
      <div class="ml-2 d-flex logo-items">
        <div class="div-logo-img">
          <img class="logo-img" [src]="item.path" alt="logo-img" />
        </div>
        <div
          class="one-line-text"
          [title]="item.name"
        >
          {{ item.name }}
        </div>
        <mat-icon
          *ngIf="item.id == selectItem.id"
          aria-hidden="false"
          aria-label="check icon"
          class="icon-logo-checked"
          fontIcon="check_small"
        ></mat-icon>
      </div>
    </div>
  </mat-menu>
</div>
